import React from "react";
import { motion } from "framer-motion";
import { useIsMobile } from "@/hooks/use-mobile";
const Header = () => {
  const isMobile = useIsMobile();
  return <motion.header className={`w-full ${isMobile ? 'py-6' : 'py-8'} flex justify-center items-center flex-col`} initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.4
  }}>
      <h1 className="text-2xl font-semibold tracking-tight">
        <span className="bg-clip-text bg-gradient-to-r from-primary to-primary/80 text-4xl font-extrabold text-violet-600">Clips</span>
      </h1>
      <p className="text-sm text-muted-foreground mt-1">by Keven</p>
    </motion.header>;
};
export default Header;